const $inject = ['$timeout', 'moment'];

const lbIFrameOnLoad = function ($timeout, moment) {
  return {
    scope: {
      callBack: '&iframeOnload',
    },
    link: function (scope, element, attrs) {
      element.on('load', function () {
        return scope.callBack();
      });
    },
  };
};

lbIFrameOnLoad.$inject = $inject;

export default lbIFrameOnLoad;



// WEBPACK FOOTER //
// ./src/directives/lbIFrameOnLoad.js